module.exports = __webpack_public_path__ + "static/media/inlaws-female-perspective.c597019d.svg";